import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import {computed, ref} from "vue";
import httpClient from "@/tools/http-client";

export const useSettingsStore
    = defineStore('settingsStore', () => {

        const crud = useCrudStore(environment.appConfig.baseApiUrl + "settings");
        const user= ref ( {});
        const options = ref([])
        const orderCount = ref(0)
    const deliveryCost = ref(0)

    async function loadSetting() {
        console.log("loadSetting");
        await clearData();
        crud.startLoading();
        try {
            const resp = await httpClient.get(crud.endpoint.value);
            user.value = resp.data?.user || {};
            options.value = resp.data?.options || [];
            orderCount.value = resp.data?.order_count || 0;
            deliveryCost.value = resp.data?.delivery_cost || 700;
            crud.clearLoading();
        } catch (e) {
            crud.setError(e);
        }
    }
    async function clearData() {
        user.value = {};
        orderCount.value = 0;
        await crud.clearData();
    }
    function getOption(optionKey) {
        const found = (options.value || []).find(item => item.key === optionKey);
        return found?.value;
    }
    const userRoles = computed(() => user.value.roles || []);
    function hasRole(role) {
        return userRoles.value.includes(role);
    }
    function hasAnyRole(roles) {
        return (roles || []).some(role => userRoles.value.includes(role));
    }
    return {
        ...crud,
        loadSetting,
        user,
        clearData,
        getOption,
        userRoles,
        hasRole,
        hasAnyRole,
        orderCount,
        deliveryCost
    }
});
